import {createContext, useContext, useEffect} from 'react';

import {useThemePreference} from '../hooks/useThemePreference';

import type {Theme} from '../hooks/useThemePreference';
import type {FC, PropsWithChildren} from 'react';

interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export const ThemeProvider: FC<PropsWithChildren> = ({children}) => {
  const {theme, setPreferredTheme} = useThemePreference();

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return (
    <ThemeContext.Provider value={{theme, setTheme: setPreferredTheme}}>
      {children}
    </ThemeContext.Provider>
  );
};

/** Like `useTheme`, but for hosts that don't mount a `ThemeProvider` (e.g. ops-web). */
export function useOptionalTheme(): ThemeContextValue | null {
  return useContext(ThemeContext);
}

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
